export default __webpack_public_path__ + "static/media/casaduana_registro.e92a630a.jpg";